import { v4 as uuidv4 } from 'uuid';
import {
    ParsedDataRow,
    PropertyFormValues,
    PropertyManualForm,
} from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { SupportInputType } from 'features/my-zone/support-requests/components/support-requests-modals/types';
import { resetChallengeData } from '../../modals/request-new-location/request-property/flow-config/support-request-results-modal/components/ask-for-review/utils';

export const mapCsvColumnsToRequiredFields = (
    mappedFileData: PropertyFormValues,
    flowType: SupportInputType,
) => {
    if (flowType === 'file' && 'parsedData' in mappedFileData) {
        const matchingValues = new Set(Object.values(mappedFileData.matching).filter(Boolean));
        const matchingKeys = new Set(Object.keys(mappedFileData.matching));

        const remappedData = mappedFileData.parsedData.data.map((row) => {
            const newRow: ParsedDataRow = {
                ...resetChallengeData,
                id: uuidv4(),
                zip_code: '',
            };

            for (const [key, matchedCol] of Object.entries(mappedFileData.matching)) {
                if (matchedCol) {
                    newRow[key] = row[matchedCol];
                }
            }

            for (const [col, value] of Object.entries(row)) {
                if (!matchingValues.has(col) && !matchingKeys.has(col)) {
                    newRow[col] = value;
                }
            }

            return newRow;
        });

        return {
            ...mappedFileData,
            parsedData: {
                ...mappedFileData.parsedData,
                data: remappedData,
            },
        };
    } else {
        return {
            ...mappedFileData,

            parsedData: {
                data: (mappedFileData as PropertyManualForm).properties.map((property) => {
                    const { address, ...rest } = property;
                    return {
                        ...resetChallengeData,
                        ...rest,
                        formatted_address: address,
                        id: uuidv4(),
                    };
                }),
            },
            matching: {
                formatted_address: 'formatted_address',
                name: 'name',
                zip_code: 'zip_code',
            },
        };
    }
};
